/**
 * WP05 screens: inventory, suppliers & purchasing, payables, expenses, finance reports, Overview KPI picker.
 * One row per key: [key, English, 中文, Bahasa Melayu].
 */
const ROWS = [
  ["nav.suppliers", "Suppliers", "供应商", "Pembekal"],
  ["nav.purchaseOrders", "Purchase orders", "采购单", "Pesanan belian"],
  ["nav.supplierInvoices", "Supplier invoices", "供应商发票", "Invois pembekal"],
  ["nav.payables", "Payables", "应付账款", "Akaun belum bayar"],
  ["nav.expenses", "Expenses", "费用", "Perbelanjaan"],
  ["nav.reports", "Reports", "报表", "Laporan"],
  ["w5.cancel", "Cancel", "取消", "Batal"],
  ["w5.save", "Save", "保存", "Simpan"],
  ["w5.saving", "Saving…", "保存中…", "Menyimpan…"],
  ["w5.close", "Close", "关闭", "Tutup"],
  ["w5.add", "Add", "添加", "Tambah"],
  ["w5.remove", "Remove", "移除", "Buang"],
  ["w5.none", "—", "—", "—"],
  ["w5.optional", "optional", "可选", "pilihan"],
  ["w5.branch", "Branch", "分店", "Cawangan"],
  ["w5.date", "Date", "日期", "Tarikh"],
  ["w5.status", "Status", "状态", "Status"],
  ["w5.total", "Total", "合计", "Jumlah"],
  ["w5.note", "Note", "备注", "Nota"],
  ["w5.reason", "Reason", "原因", "Sebab"],
  ["w5.done", "Saved", "已保存", "Disimpan"],
  ["w5.currencyNote", "Amounts are shown per currency and never added across currencies.", "金额按币种分别显示，不同币种绝不相加。", "Amaun dipaparkan mengikut mata wang dan tidak dijumlahkan merentas mata wang."],

  ["kpi.collected_today", "Collected today", "今日收款", "Kutipan hari ini"],
  ["kpi.appointments_today", "Appointments today", "今日预约", "Temujanji hari ini"],
  ["kpi.avg_ticket", "Average ticket", "平均客单价", "Purata bil"],
  ["kpi.new_customers", "New customers", "新顾客", "Pelanggan baharu"],
  ["kpi.month_profit", "This month profit", "本月利润", "Untung bulan ini"],
  ["kpi.month_revenue", "This month revenue", "本月收入", "Hasil bulan ini"],
  ["kpi.stock_value", "Stock value", "库存价值", "Nilai stok"],
  ["kpi.payables_owed", "Owed to suppliers", "应付供应商", "Hutang kepada pembekal"],
  ["kpi.estimate", "estimate", "估算", "anggaran"],
  ["kpi.edit", "Choose numbers", "选择显示指标", "Pilih angka"],
  ["kpi.title", "Numbers on your overview", "概览显示的指标", "Angka pada gambaran keseluruhan"],
  ["kpi.hint", "Pick exactly four.", "请选择四项。", "Pilih tepat empat."],
  ["kpi.profitHint", "Revenue − cost of goods − payroll − expenses; payroll is estimated until the period is locked.", "收入 − 销售成本 − 工资 − 费用；工资周期锁定前为估算。", "Hasil − kos barang − gaji − perbelanjaan; gaji dianggarkan sehingga tempoh dikunci."],
  ["overview.action.low_stock", "{n} items low on stock", "{n} 项库存不足", "{n} item stok rendah"],
  ["overview.action.pending_adjustments", "{n} stock adjustments to approve", "{n} 笔库存调整待审批", "{n} pelarasan stok untuk diluluskan"],
  ["overview.action.counts_to_approve", "{n} stock counts to approve", "{n} 次盘点待审批", "{n} kiraan stok untuk diluluskan"],
  ["overview.action.supplier_invoices_due", "{n} supplier invoices due", "{n} 张供应商发票到期", "{n} invois pembekal perlu dibayar"],
  ["overview.action.draft_expenses", "{n} recurring expenses to confirm", "{n} 笔定期费用待确认", "{n} perbelanjaan berulang untuk disahkan"],

  ["inv.sub", "Stock on hand, its value at moving-average cost, and every movement.", "现有库存、按移动加权平均成本计算的价值，以及每一笔变动。", "Stok sedia ada, nilainya pada kos purata bergerak, dan setiap pergerakan."],
  ["inv.tab.stock", "Stock", "库存", "Stok"],
  ["inv.tab.counts", "Stock counts", "盘点", "Kiraan stok"],
  ["inv.tab.recipes", "Service recipes", "服务耗材配方", "Resipi servis"],
  ["inv.tab.adjustments", "Adjustments", "调整", "Pelarasan"],
  ["inv.stockValue", "Stock value", "库存价值", "Nilai stok"],
  ["inv.lowStock", "Low stock", "库存不足", "Stok rendah"],
  ["inv.materialsMonth", "Service materials this month", "本月服务耗材成本", "Bahan servis bulan ini"],
  ["inv.items", "Items", "品项", "Item"],
  ["inv.col.item", "Item", "品项", "Item"],
  ["inv.col.onHand", "On hand", "现有", "Ada"],
  ["inv.col.avgCost", "Avg cost", "平均成本", "Kos purata"],
  ["inv.col.value", "Value", "价值", "Nilai"],
  ["inv.col.reorder", "Reorder at", "补货点", "Pesan semula pada"],
  ["inv.status.ok", "OK", "正常", "OK"],
  ["inv.status.low", "Low", "不足", "Rendah"],
  ["inv.status.out", "Out", "缺货", "Habis"],
  ["inv.status.negative", "Negative", "负库存", "Negatif"],
  ["inv.usage.retail", "Retail", "零售", "Runcit"],
  ["inv.usage.salon_use", "Salon use", "院内使用", "Kegunaan salon"],
  ["inv.usage.both", "Retail + salon", "零售 + 院内", "Runcit + salon"],
  ["inv.receive", "Receive goods", "收货", "Terima barang"],
  ["inv.transfer", "Transfer", "调拨", "Pindahan"],
  ["inv.count", "Count", "盘点", "Kira"],
  ["inv.adjust", "Adjust / waste", "调整 / 报损", "Laras / rosak"],
  ["inv.movements", "Movements", "库存变动", "Pergerakan"],
  ["inv.kind.opening", "Opening balance", "期初", "Baki pembukaan"],
  ["inv.kind.receipt", "Received", "收货", "Diterima"],
  ["inv.kind.sale", "Sold", "销售", "Dijual"],
  ["inv.kind.sale_return", "Returned by customer", "顾客退货", "Dipulangkan pelanggan"],
  ["inv.kind.salon_use", "Salon use", "院内使用", "Kegunaan salon"],
  ["inv.kind.recipe", "Used in service", "服务耗用", "Digunakan dalam servis"],
  ["inv.kind.recipe_adjust", "Usage correction", "耗用更正", "Pembetulan penggunaan"],
  ["inv.kind.transfer_out", "Transferred out", "调出", "Dipindah keluar"],
  ["inv.kind.transfer_in", "Transferred in", "调入", "Dipindah masuk"],
  ["inv.kind.adjustment", "Adjustment", "调整", "Pelarasan"],
  ["inv.kind.wastage", "Wastage", "报损", "Pembaziran"],
  ["inv.kind.count", "Count variance", "盘点差异", "Varians kiraan"],
  ["inv.kind.supplier_return", "Returned to supplier", "退回供应商", "Dipulangkan kepada pembekal"],
  ["inv.source.grn", "goods receipt", "收货单", "nota terimaan"],
  ["inv.source.opening", "opening", "期初", "pembukaan"],
  ["inv.source.moving_average", "moving average", "移动平均", "purata bergerak"],
  ["inv.source.transfer", "transfer cost", "调拨成本", "kos pindahan"],
  ["inv.source.count", "count", "盘点", "kiraan"],
  ["inv.source.manual", "manual", "手动", "manual"],
  ["inv.qty", "Quantity", "数量", "Kuantiti"],
  ["inv.qtyIn", "Quantity ({unit})", "数量（{unit}）", "Kuantiti ({unit})"],
  ["inv.fromBranch", "From", "调出分店", "Dari"],
  ["inv.toBranch", "To", "调入分店", "Ke"],
  ["inv.addLine", "Add item", "添加品项", "Tambah item"],
  ["inv.chooseItem", "Choose an item", "选择品项", "Pilih item"],
  ["inv.transferDone", "Transfer recorded", "调拨已记录", "Pindahan direkodkan"],
  ["inv.transferHint", "Stock moves at its average cost, so the total value stays the same.", "库存按平均成本调拨，总价值保持不变。", "Stok dipindah pada kos puratanya, jadi jumlah nilai kekal sama."],
  ["inv.adjustKind.adjustment", "Correction (+/−)", "更正（+/−）", "Pembetulan (+/−)"],
  ["inv.adjustKind.wastage", "Wastage / damaged", "报损 / 损坏", "Rosak / terbuang"],
  ["inv.adjustKind.salon_use", "Salon use", "院内使用", "Kegunaan salon"],
  ["inv.adjustHint", "Use negative numbers to take stock out. Corrections and wastage may need approval by someone else.", "出库请填负数。更正和报损可能需要他人审批。", "Guna nombor negatif untuk keluarkan stok. Pembetulan dan pembaziran mungkin perlu kelulusan orang lain."],
  ["inv.adjustPending", "Sent for approval", "已提交审批", "Dihantar untuk kelulusan"],
  ["inv.adjustPosted", "Stock updated", "库存已更新", "Stok dikemas kini"],
  ["inv.approve", "Approve", "批准", "Luluskan"],
  ["inv.reject", "Reject", "拒绝", "Tolak"],
  ["inv.adj.status.pending", "Waiting for approval", "待审批", "Menunggu kelulusan"],
  ["inv.adj.status.approved", "Approved", "已批准", "Diluluskan"],
  ["inv.adj.status.rejected", "Rejected", "已拒绝", "Ditolak"],
  ["inv.adj.empty", "No adjustments yet.", "暂无调整记录。", "Belum ada pelarasan."],
  ["inv.estimate", "Value about {amount}", "约值 {amount}", "Nilai kira-kira {amount}"],
  ["inv.countStart", "Start a stock count", "开始盘点", "Mulakan kiraan stok"],
  ["inv.countHint", "Expected quantities are frozen when you start. Sales during the count are still recorded.", "开始时冻结账面数量。盘点期间的销售仍会记录。", "Kuantiti dijangka dibekukan semasa mula. Jualan semasa kiraan tetap direkodkan."],
  ["inv.count.expected", "Expected", "账面", "Dijangka"],
  ["inv.count.counted", "Counted", "实盘", "Dikira"],
  ["inv.count.variance", "Variance", "差异", "Varians"],
  ["inv.count.submit", "Submit count", "提交盘点", "Hantar kiraan"],
  ["inv.count.post", "Approve & post variance", "批准并过账差异", "Luluskan & catat varians"],
  ["inv.count.cancel", "Cancel count", "取消盘点", "Batal kiraan"],
  ["inv.count.saveCounts", "Save counts", "保存实盘数", "Simpan kiraan"],
  ["inv.count.status.open", "Counting", "盘点中", "Sedang dikira"],
  ["inv.count.status.submitted", "Waiting for approval", "待审批", "Menunggu kelulusan"],
  ["inv.count.status.posted", "Posted", "已过账", "Dicatat"],
  ["inv.count.status.cancelled", "Cancelled", "已取消", "Dibatalkan"],
  ["inv.count.none", "No stock counts yet.", "暂无盘点。", "Belum ada kiraan stok."],
  ["inv.count.approvalHint", "Someone other than the person who counted approves the variance (the owner may approve their own).", "差异需由盘点人以外的人批准（店主可自行批准）。", "Varians diluluskan oleh orang lain selain pengira (pemilik boleh meluluskan sendiri)."],
  ["inv.recipe.service", "Service", "服务", "Servis"],
  ["inv.recipe.uses", "Uses", "耗用", "Menggunakan"],
  ["inv.recipe.cost", "Standard cost", "标准成本", "Kos standard"],
  ["inv.recipe.edit", "Edit recipe", "编辑配方", "Sunting resipi"],
  ["inv.recipe.new", "New recipe", "新建配方", "Resipi baharu"],
  ["inv.recipe.none", "No recipes yet. Add one so materials are taken from stock when the service is paid.", "暂无配方。设置后，服务付款时会自动扣减耗材库存。", "Belum ada resipi. Tambah supaya bahan ditolak daripada stok apabila servis dibayar."],
  ["inv.recipe.hint", "Standard usage per service. A new version applies from now; past sales keep the version they used.", "每次服务的标准用量。新版本从现在起生效；过往销售保留当时的版本。", "Penggunaan standard setiap servis. Versi baharu berkuat kuasa sekarang; jualan lalu kekal versi asal."],
  ["inv.recipe.saved", "Recipe saved", "配方已保存", "Resipi disimpan"],
  ["inv.empty", "No stocked products yet", "暂无库存商品", "Belum ada produk berstok"],
  ["inv.empty.sub", "Turn on stock tracking for a product in Services, then receive goods from a supplier.", "在“服务”中为商品开启库存追踪，然后向供应商收货。", "Hidupkan penjejakan stok untuk produk dalam Servis, kemudian terima barang daripada pembekal."],
  ["inv.reorderPoint", "Reorder point", "补货点", "Titik pesanan semula"],
  ["inv.unit", "Stock unit", "库存单位", "Unit stok"],
  ["inv.packSize", "Units per pack", "每包装单位数", "Unit setiap pek"],
  ["inv.receiveHint", "Receiving against a purchase order is in Purchase orders. Here you can receive without one.", "按采购单收货请到“采购单”。此处可直接收货。", "Penerimaan berdasarkan pesanan belian ada di Pesanan belian. Di sini boleh terima tanpa pesanan."],
  ["inv.packs", "Packs", "包装数", "Pek"],
  ["inv.packCost", "Cost per pack", "每包装成本", "Kos setiap pek"],
  ["inv.supplier", "Supplier", "供应商", "Pembekal"],
  ["inv.received", "Goods received", "已收货", "Barang diterima"],

  ["sup.sub", "Who you buy from, their payment terms, and how much you owe them.", "采购对象、付款条件及欠款。", "Daripada siapa anda membeli, terma bayaran dan hutang anda."],
  ["sup.new", "New supplier", "新增供应商", "Pembekal baharu"],
  ["sup.edit", "Edit supplier", "编辑供应商", "Sunting pembekal"],
  ["sup.name", "Name", "名称", "Nama"],
  ["sup.contact", "Contact person", "联系人", "Orang hubungan"],
  ["sup.email", "Email", "电邮", "E-mel"],
  ["sup.phone", "Phone", "电话", "Telefon"],
  ["sup.address", "Address", "地址", "Alamat"],
  ["sup.currency", "Currency", "币种", "Mata wang"],
  ["sup.terms", "Payment terms", "付款期限", "Terma bayaran"],
  ["sup.termsDays", "{n} days", "{n} 天", "{n} hari"],
  ["sup.taxId", "Tax ID", "税号", "ID cukai"],
  ["sup.notes", "Notes", "备注", "Nota"],
  ["sup.owed", "Owed", "欠款", "Hutang"],
  ["sup.overdue", "Overdue", "逾期", "Tertunggak"],
  ["sup.nextDue", "Next due", "下次到期", "Tarikh akhir seterusnya"],
  ["sup.active", "Active", "启用", "Aktif"],
  ["sup.inactive", "Inactive", "停用", "Tidak aktif"],
  ["sup.empty", "No suppliers yet", "暂无供应商", "Belum ada pembekal"],
  ["sup.empty.sub", "Add the companies you buy products and consumables from.", "添加您采购商品和耗材的公司。", "Tambah syarikat tempat anda membeli produk dan bahan."],
  ["sup.invoices", "Invoices", "发票", "Invois"],
  ["sup.payments", "Payment history", "付款记录", "Sejarah bayaran"],
  ["sup.creditNotes", "Credit notes", "贷项通知单", "Nota kredit"],
  ["sup.unapplied", "Paid in advance / credits not applied: {amount}", "预付 / 未冲销贷项：{amount}", "Bayaran awal / kredit belum digunakan: {amount}"],

  ["po.sub", "Order from suppliers, receive in parts, and keep cost prices up to date.", "向供应商下单、分批收货，并保持成本价最新。", "Pesan daripada pembekal, terima secara berperingkat dan kemas kini harga kos."],
  ["po.new", "New purchase order", "新建采购单", "Pesanan belian baharu"],
  ["po.number", "PO", "采购单号", "PO"],
  ["po.supplier", "Supplier", "供应商", "Pembekal"],
  ["po.status.draft", "Draft", "草稿", "Draf"],
  ["po.status.sent", "Sent", "已发送", "Dihantar"],
  ["po.status.partially_received", "Partly received", "部分收货", "Diterima sebahagian"],
  ["po.status.received", "Received", "已收货", "Diterima"],
  ["po.status.closed", "Closed", "已关闭", "Ditutup"],
  ["po.status.cancelled", "Cancelled", "已取消", "Dibatalkan"],
  ["po.orderDate", "Order date", "下单日期", "Tarikh pesanan"],
  ["po.expected", "Expected", "预计到货", "Dijangka"],
  ["po.item", "Item", "品项", "Item"],
  ["po.packs", "Packs", "包装数", "Pek"],
  ["po.packSize", "Units / pack", "单位/包装", "Unit / pek"],
  ["po.packCost", "Cost / pack", "每包装成本", "Kos / pek"],
  ["po.received", "Received", "已收", "Diterima"],
  ["po.send", "Mark as sent", "标记为已发送", "Tandakan dihantar"],
  ["po.cancel", "Cancel order", "取消采购单", "Batal pesanan"],
  ["po.close", "Close (no more deliveries)", "关闭（不再收货）", "Tutup (tiada lagi penghantaran)"],
  ["po.receive", "Receive delivery", "登记收货", "Terima penghantaran"],
  ["po.receiveHint", "Enter what actually arrived and the actual cost. Partial deliveries are fine.", "填写实际到货数量及实际成本。可分批收货。", "Masukkan apa yang tiba dan kos sebenar. Penghantaran separa dibenarkan."],
  ["po.landed", "Freight / landed cost", "运费 / 到岸成本", "Kos penghantaran / pendaratan"],
  ["po.landedHint", "Spread over the lines by value and added to stock cost.", "按金额分摊到各品项并计入库存成本。", "Diagihkan mengikut nilai dan ditambah kepada kos stok."],
  ["po.supplierRef", "Delivery note no.", "送货单号", "No. nota hantaran"],
  ["po.empty", "No purchase orders yet", "暂无采购单", "Belum ada pesanan belian"],
  ["po.empty.sub", "Create an order for a supplier; receive it when the goods arrive.", "为供应商建立订单，到货时登记收货。", "Cipta pesanan untuk pembekal; terima apabila barang tiba."],
  ["po.saved", "Purchase order saved", "采购单已保存", "Pesanan belian disimpan"],
  ["po.receivedOk", "Delivery received · stock and costs updated", "已收货 · 库存与成本已更新", "Penghantaran diterima · stok dan kos dikemas kini"],
  ["po.receipts", "Deliveries", "收货记录", "Penghantaran"],
  ["po.sendNow", "Mark as sent now", "立即标记为已发送", "Tandakan dihantar sekarang"],

  ["si.sub", "Bills from suppliers: what's due, what's paid, and what's overdue.", "供应商账单：到期、已付及逾期情况。", "Bil daripada pembekal: perlu dibayar, telah dibayar dan tertunggak."],
  ["si.new", "Record invoice", "登记发票", "Rekod invois"],
  ["si.invoiceNo", "Invoice no.", "发票号", "No. invois"],
  ["si.invoiceDate", "Invoice date", "发票日期", "Tarikh invois"],
  ["si.dueDate", "Due date", "到期日", "Tarikh akhir"],
  ["si.dueHint", "Leave empty to use the invoice date + the supplier's terms.", "留空则按发票日期 + 供应商付款期限计算。", "Biarkan kosong untuk guna tarikh invois + terma pembekal."],
  ["si.subtotal", "Amount before tax", "税前金额", "Amaun sebelum cukai"],
  ["si.tax", "Tax", "税额", "Cukai"],
  ["si.paid", "Paid", "已付", "Dibayar"],
  ["si.outstanding", "Outstanding", "未付", "Baki"],
  ["si.status.open", "Open", "未付", "Belum dibayar"],
  ["si.status.partially_paid", "Partly paid", "部分已付", "Dibayar sebahagian"],
  ["si.status.paid", "Paid", "已付清", "Dibayar"],
  ["si.status.void", "Void", "已作废", "Batal"],
  ["si.overdueDays", "{n} days overdue", "逾期 {n} 天", "Tertunggak {n} hari"],
  ["si.pay", "Record payment", "登记付款", "Rekod bayaran"],
  ["si.payHint", "Pay part or all. Without a choice, the oldest due invoices are paid first.", "可部分或全额付款。未指定时优先支付最早到期的发票。", "Bayar sebahagian atau semua. Tanpa pilihan, invois tertua dibayar dahulu."],
  ["si.method", "Method", "付款方式", "Kaedah"],
  ["si.method.bank_transfer", "Bank transfer", "银行转账", "Pindahan bank"],
  ["si.method.cash", "Cash", "现金", "Tunai"],
  ["si.method.card", "Card", "刷卡", "Kad"],
  ["si.method.cheque", "Cheque", "支票", "Cek"],
  ["si.method.other", "Other", "其他", "Lain-lain"],
  ["si.reference", "Reference", "参考号", "Rujukan"],
  ["si.fromDrawer", "Paid from today's cash drawer", "从今日钱箱支付", "Dibayar dari laci tunai hari ini"],
  ["si.paidOk", "Payment recorded", "付款已登记", "Bayaran direkodkan"],
  ["si.void", "Void invoice", "作废发票", "Batalkan invois"],
  ["si.empty", "No supplier invoices", "暂无供应商发票", "Tiada invois pembekal"],
  ["si.filter.all", "All", "全部", "Semua"],
  ["si.filter.open", "Unpaid", "未付", "Belum dibayar"],
  ["si.filter.overdue", "Overdue", "逾期", "Tertunggak"],
  ["si.filter.due_soon", "Due soon", "即将到期", "Hampir tiba tempoh"],
  ["si.filter.paid", "Paid", "已付清", "Dibayar"],
  ["si.saved", "Invoice recorded", "发票已登记", "Invois direkodkan"],
  ["si.purchaseOrder", "Purchase order", "采购单", "Pesanan belian"],

  ["ap.sub", "What you owe each supplier and how late it is.", "欠各供应商的金额及逾期情况。", "Hutang kepada setiap pembekal dan berapa lewat."],
  ["ap.bucket.current", "Not yet due", "未到期", "Belum tiba tempoh"],
  ["ap.bucket.d1_30", "1–30 days", "1–30 天", "1–30 hari"],
  ["ap.bucket.d31_60", "31–60 days", "31–60 天", "31–60 hari"],
  ["ap.bucket.d61_90", "61–90 days", "61–90 天", "61–90 hari"],
  ["ap.bucket.d90_plus", "90+ days", "90 天以上", "90+ hari"],
  ["ap.owed", "Owed", "应付", "Hutang"],
  ["ap.unapplied", "Unapplied", "未冲销", "Belum digunakan"],
  ["ap.netOwed", "Net owed", "净应付", "Hutang bersih"],
  ["ap.dueSoon", "Due soon & overdue", "即将到期及逾期", "Hampir tiba tempoh & tertunggak"],
  ["ap.recentPayments", "Recent payments", "最近付款", "Bayaran terkini"],
  ["ap.asOf", "As of {date}", "截至 {date}", "Setakat {date}"],
  ["ap.empty", "Nothing owed to suppliers", "暂无应付供应商款项", "Tiada hutang kepada pembekal"],
  ["ap.supplier", "Supplier", "供应商", "Pembekal"],

  ["exp.sub", "Rent, utilities and other running costs — paid and unpaid.", "租金、水电及其他营运费用 — 已付与未付。", "Sewa, utiliti dan kos operasi lain — dibayar dan belum dibayar."],
  ["exp.new", "New expense", "新增费用", "Perbelanjaan baharu"],
  ["exp.category", "Category", "类别", "Kategori"],
  ["exp.description", "Description", "说明", "Keterangan"],
  ["exp.amount", "Amount (incl. tax)", "金额（含税）", "Amaun (termasuk cukai)"],
  ["exp.tax", "Tax included", "其中税额", "Cukai termasuk"],
  ["exp.date", "Expense date", "费用日期", "Tarikh perbelanjaan"],
  ["exp.headOffice", "Whole business (head office)", "全公司（总部）", "Seluruh perniagaan (ibu pejabat)"],
  ["exp.status.draft", "Draft", "草稿", "Draf"],
  ["exp.status.unpaid", "Unpaid", "未付", "Belum dibayar"],
  ["exp.status.paid", "Paid", "已付", "Dibayar"],
  ["exp.status.void", "Void", "已作废", "Batal"],
  ["exp.pay", "Mark paid", "标记为已付", "Tandakan dibayar"],
  ["exp.confirm", "Confirm", "确认", "Sahkan"],
  ["exp.void", "Void", "作废", "Batalkan"],
  ["exp.voidHint", "A paid expense can't be edited. Void it and enter the correct one.", "已付费用不能修改，请作废后重新录入。", "Perbelanjaan yang dibayar tidak boleh disunting. Batalkan dan masukkan yang betul."],
  ["exp.attach", "Attach receipt", "上传收据", "Lampirkan resit"],
  ["exp.attachHint", "PDF, JPG, PNG or WebP · max 5 MB · stored privately", "PDF、JPG、PNG 或 WebP · 最大 5 MB · 私密保存", "PDF, JPG, PNG atau WebP · maks 5 MB · disimpan secara peribadi"],
  ["exp.attachments", "Receipts", "收据", "Resit"],
  ["exp.uploaded", "Receipt attached", "收据已上传", "Resit dilampirkan"],
  ["exp.totalN", "{amount} this period", "本期 {amount}", "{amount} tempoh ini"],
  ["exp.unpaidN", "{amount} unpaid", "未付 {amount}", "{amount} belum dibayar"],
  ["exp.draftsN", "{n} drafts to confirm", "{n} 笔草稿待确认", "{n} draf untuk disahkan"],
  ["exp.recurring", "Recurring", "定期费用", "Berulang"],
  ["exp.recurring.new", "New recurring expense", "新增定期费用", "Perbelanjaan berulang baharu"],
  ["exp.recurring.day", "Day {n} of each month", "每月 {n} 日", "Hari {n} setiap bulan"],
  ["exp.recurring.dayLabel", "Day of month", "每月日期", "Hari dalam bulan"],
  ["exp.recurring.starts", "Starts", "开始日期", "Bermula"],
  ["exp.recurring.hint", "A draft entry is created each month; confirm it when the bill arrives.", "每月自动生成草稿，收到账单时确认即可。", "Draf dicipta setiap bulan; sahkan apabila bil tiba."],
  ["exp.recurring.none", "No recurring expenses.", "暂无定期费用。", "Tiada perbelanjaan berulang."],
  ["exp.recurring.active", "Active", "启用", "Aktif"],
  ["exp.recurring.paused", "Paused", "已暂停", "Dijeda"],
  ["exp.saved", "Expense saved", "费用已保存", "Perbelanjaan disimpan"],
  ["exp.empty", "No expenses in this period", "本期暂无费用", "Tiada perbelanjaan dalam tempoh ini"],
  ["exp.empty.sub", "Record rent, utilities and other costs so your profit is complete.", "登记租金、水电等费用，利润才完整。", "Rekod sewa, utiliti dan kos lain supaya keuntungan anda lengkap."],
  ["exp.paidNow", "Already paid", "已付款", "Sudah dibayar"],
  ["exp.cat.rent", "Rent", "租金", "Sewa"],
  ["exp.cat.utilities", "Utilities", "水电", "Utiliti"],
  ["exp.cat.marketing", "Marketing", "营销", "Pemasaran"],
  ["exp.cat.supplies", "Supplies", "耗品", "Bekalan"],
  ["exp.cat.software", "Software", "软件", "Perisian"],
  ["exp.cat.other", "Other", "其他", "Lain-lain"],

  ["rep.sub", "How much money the salon made, where it went, and what you owe.", "店铺赚了多少、钱花在哪里，以及欠款情况。", "Berapa banyak salon untung, ke mana wang pergi dan apa yang anda hutang."],
  ["rep.tab.pnl", "Profit & loss", "损益表", "Untung & rugi"],
  ["rep.tab.cash", "Cash flow", "现金流", "Aliran tunai"],
  ["rep.tab.liabilities", "Liabilities", "负债", "Liabiliti"],
  ["rep.tab.valuation", "Stock value", "库存价值", "Nilai stok"],
  ["rep.tab.sales", "Sales breakdown", "销售明细", "Pecahan jualan"],
  ["rep.tab.variance", "Material usage", "耗材差异", "Penggunaan bahan"],
  ["rep.from", "From", "从", "Dari"],
  ["rep.to", "To", "至", "Hingga"],
  ["rep.allBranches", "All my branches", "我的所有分店", "Semua cawangan saya"],
  ["rep.csv", "Download CSV", "下载 CSV", "Muat turun CSV"],
  ["rep.thisMonth", "This month", "本月", "Bulan ini"],
  ["rep.lastMonth", "Last month", "上月", "Bulan lepas"],
  ["rep.pnl.service", "Service revenue", "服务收入", "Hasil servis"],
  ["rep.pnl.retail", "Retail revenue", "零售收入", "Hasil runcit"],
  ["rep.pnl.package", "Package redeem (recognised)", "配套使用（已确认收入）", "Package redeem (recognised)"],
  ["rep.pnl.refunds", "Refunds", "退款", "Bayaran balik"],
  ["rep.pnl.bonus", "Bonus credit used (promotional)", "赠送储值使用（促销成本）", "Kredit bonus digunakan (promosi)"],
  ["rep.pnl.netRevenue", "Net revenue", "净收入", "Hasil bersih"],
  ["rep.pnl.retailCogs", "Cost of products sold", "商品销售成本", "Kos produk dijual"],
  ["rep.pnl.materials", "Service materials", "服务耗材", "Bahan servis"],
  ["rep.pnl.shrinkage", "Wastage & stock differences", "报损及盘点差异", "Pembaziran & perbezaan stok"],
  ["rep.pnl.grossProfit", "Gross profit", "毛利", "Untung kasar"],
  ["rep.pnl.margin", "{pct}% margin", "毛利率 {pct}%", "Margin {pct}%"],
  ["rep.pnl.payroll", "Payroll", "工资", "Gaji"],
  ["rep.pnl.payrollEstimate", "estimate — payroll period not locked", "估算 — 工资周期未锁定", "anggaran — tempoh gaji belum dikunci"],
  ["rep.pnl.payrollActual", "from approved payroll", "来自已批准的工资", "daripada gaji yang diluluskan"],
  ["rep.pnl.expenses", "Expenses", "费用", "Perbelanjaan"],
  ["rep.pnl.netProfit", "Net profit", "净利润", "Untung bersih"],
  ["rep.pnl.discounts", "Discounts given: {amount}", "已给折扣：{amount}", "Diskaun diberi: {amount}"],
  ["rep.pnl.drafts", "{n} draft expenses are not included until confirmed.", "{n} 笔草稿费用确认前不计入。", "{n} draf perbelanjaan tidak dikira sehingga disahkan."],
  ["rep.pnl.headOffice", "Head-office expenses not in this branch view: {amount}", "未计入此分店的总部费用：{amount}", "Perbelanjaan ibu pejabat tidak dalam paparan cawangan ini: {amount}"],
  ["rep.pnl.model", "Revenue is recognised when a sale is paid. Store credit and packages are counted once — top-ups and package sales are liabilities until used.", "收入在销售付款时确认。储值和配套只计一次 — 充值和配套销售在使用前属于负债。", "Hasil diiktiraf apabila jualan dibayar. Kredit dan pakej dikira sekali — tambah nilai dan jualan pakej ialah liabiliti sehingga digunakan."],
  ["rep.pnl.empty", "No sales or costs in this period.", "本期没有销售或成本。", "Tiada jualan atau kos dalam tempoh ini."],
  ["rep.cash.collected", "Money collected", "收款", "Wang dikutip"],
  ["rep.cash.storeCredit", "Paid with store credit (not new money): {amount}", "以储值支付（非新增现金）：{amount}", "Dibayar dengan kredit kedai (bukan wang baharu): {amount}"],
  ["rep.cash.refunds", "Refunds paid out", "退款支出", "Bayaran balik dibayar"],
  ["rep.cash.supplier", "Paid to suppliers", "支付供应商", "Dibayar kepada pembekal"],
  ["rep.cash.expenses", "Expenses paid", "已付费用", "Perbelanjaan dibayar"],
  ["rep.cash.net", "Net cash movement", "现金净流量", "Pergerakan tunai bersih"],
  ["rep.cash.payrollNote", "Salary payouts are not tracked here yet.", "工资发放暂未在此追踪。", "Pembayaran gaji belum dijejak di sini."],
  ["rep.method.cash", "Cash", "现金", "Tunai"],
  ["rep.method.external_card", "Card terminal", "刷卡机", "Terminal kad"],
  ["rep.method.bank_transfer", "Bank transfer", "银行转账", "Pindahan bank"],
  ["rep.method.stripe", "Online (Stripe)", "在线（Stripe）", "Dalam talian (Stripe)"],
  ["rep.method.card", "Card", "刷卡", "Kad"],
  ["rep.method.cheque", "Cheque", "支票", "Cek"],
  ["rep.method.other", "Other", "其他", "Lain-lain"],
  ["rep.method.credit", "Store credit", "储值", "Kredit kedai"],
  ["rep.method.none", "No money back", "不退款", "Tiada wang dikembalikan"],
  ["rep.liab.packages", "Unused packages", "未使用配套", "Pakej belum digunakan"],
  ["rep.liab.creditPrincipal", "Customer credit (paid)", "顾客储值（本金）", "Kredit pelanggan (dibayar)"],
  ["rep.liab.creditBonus", "Bonus credit (promotional)", "赠送储值（促销）", "Kredit bonus (promosi)"],
  ["rep.liab.payables", "Owed to suppliers", "应付供应商", "Hutang kepada pembekal"],
  ["rep.liab.total", "Total owed", "负债合计", "Jumlah liabiliti"],
  ["rep.liab.bonusNote", "Bonus credit was given free, so it isn't counted in the total. Customer credit is shared by all branches.", "赠送储值为免费赠予，不计入合计。顾客储值为全店通用。", "Kredit bonus diberi percuma, jadi tidak dikira dalam jumlah. Kredit pelanggan dikongsi semua cawangan."],
  ["rep.val.byCategory", "By category", "按类别", "Mengikut kategori"],
  ["rep.val.slow", "Slow movers (no sales or use for {n} days)", "滞销品（{n} 天无销售或耗用）", "Bergerak perlahan (tiada jualan atau guna selama {n} hari)"],
  ["rep.val.low", "Low stock", "库存不足", "Stok rendah"],
  ["rep.val.none", "Nothing here.", "暂无。", "Tiada."],
  ["rep.val.off", "Inventory is an add-on. Add it to see stock value.", "库存为附加功能，启用后可查看库存价值。", "Inventori ialah tambahan. Tambah untuk melihat nilai stok."],
  ["rep.sales.byStaff", "By staff", "按员工", "Mengikut kakitangan"],
  ["rep.sales.byService", "By service", "按服务", "Mengikut servis"],
  ["rep.sales.byProduct", "By product", "按商品", "Mengikut produk"],
  ["rep.col.name", "Name", "名称", "Nama"],
  ["rep.col.count", "Count", "次数", "Bilangan"],
  ["rep.col.revenue", "Revenue", "收入", "Hasil"],
  ["rep.col.cost", "Cost", "成本", "Kos"],
  ["rep.col.margin", "Margin", "毛利", "Margin"],
  ["rep.var.standard", "Standard", "标准用量", "Standard"],
  ["rep.var.actual", "Actual", "实际用量", "Sebenar"],
  ["rep.var.variance", "Difference", "差异", "Perbezaan"],
  ["rep.unassigned", "Unassigned", "未分配", "Tidak ditetapkan"],
  ["rep.uncategorised", "Uncategorised", "未分类", "Tiada kategori"],
] as const;

type Key = (typeof ROWS)[number][0];
const col = (i: 1 | 2 | 3) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<Key, string>;

export const wp05 = { en: col(1), zh: col(2), ms: col(3) };
